export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/http-worker.50c02e93.worker.js");
}
